import { render, staticRenderFns } from "./LandingBanner.vue?vue&type=template&id=2f349b1e&"
import script from "./LandingBanner.vue?vue&type=script&lang=ts&"
export * from "./LandingBanner.vue?vue&type=script&lang=ts&"
import style0 from "./LandingBanner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports